import { useEffect } from 'react'
import { useErrorBoundary } from 'react-error-boundary'
import { useCart } from '@velasca/hooks/use-cart'
import type { ErrorHandlerProps } from './ErrorHandler.types'

export const ErrorHandler = ({ children }: ErrorHandlerProps) => {
  const { showBoundary } = useErrorBoundary()
  const { error } = useCart()

  useEffect(() => {
    if (error) {
      showBoundary(error)
    }
  }, [error, showBoundary])

  return children
}
